import { Reducer, UnknownAction } from 'redux';

import { SET_CURRENT_USER_ACTION, SetCurrentUserPayload } from '~/actions/currentUser';

import type { UserType } from '~/types/responses';

type CurrentUserState = {
  isLoading: boolean;
  isAuthenticated: boolean;
  user: UserType | null;
};

const initialState: CurrentUserState = {
  isLoading: false,
  isAuthenticated: false,
  user: null,
};

function isSetCurrentUserAction(action: UnknownAction): action is UnknownAction & { payload: SetCurrentUserPayload } {
  return action.type === SET_CURRENT_USER_ACTION;
}

const currentUserReducer: Reducer<CurrentUserState> = (state = initialState, action) => {
  if (isSetCurrentUserAction(action)) {
    return {
      ...state,
      ...action.payload,
    };
  }

  return state;
};

export default currentUserReducer;
